import { render, staticRenderFns } from "./ImpGenerale.vue?vue&type=template&id=04289d82&scoped=true&"
import script from "./ImpGenerale.vue?vue&type=script&lang=js&"
export * from "./ImpGenerale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04289d82",
  null
  
)

export default component.exports